import { takeEvery, call, put, select } from 'redux-saga/effects';
import {
  sendRequestGetCaptcha,
  updateData,
  requestFinished,
  selectType
} from '../reducer';
import { timeoutCall } from '../../../../../../../utils/sagaHalper';
import MainService from '../../../../../services/MainService';

function* captchaSaga(reducerName, action) {
  try {
    const captchaType = yield select(selectType, reducerName);
    const response = yield call(
      timeoutCall,
      MainService.getCaptcha,
      captchaType,
      action.payload.hasRegenerate
    );
    if (response) {
      if (response.status === 200) {
        yield put(updateData(response.data));
      }
      yield put(requestFinished(response.status, response.status === 200));
    }
  } catch (error) {
    yield put(requestFinished());
  }
}

export default function createSaga(reducerName) {
  return [takeEvery(sendRequestGetCaptcha().type, captchaSaga, reducerName)];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/main/reducers/static/states/captcha/sagas/captchaSaga.js